import { createApp } from 'vue';
import Antd from 'ant-design-vue';
import { message } from 'ant-design-vue';
import Vant from 'vant';
import '@vant/touch-emulator';
import 'ant-design-vue/dist/reset.css';
import 'vant/lib/index.css'
import App from './App.vue';
import router from './router'
import HomeFAB from '@/component/homeFAB.vue'
import { getDicts } from '@/api/dict'
import { selectDictLabel, selectDictLabels } from '@/utils/bes'
import { loadDictMap } from '@/utils/dict'

const app = createApp(App);
// 注册全局组件
app.component('HomeFAB', HomeFAB)
app.config.productionTip = false;
app.config.globalProperties.getDicts = getDicts
app.config.globalProperties.useDict = loadDictMap
app.config.globalProperties.selectDictLabel = selectDictLabel
app.config.globalProperties.selectDictLabels = selectDictLabels
app.use(router) //注册路由
app.use(Vant);
app.use(Antd).mount('#app');
router.beforeEach((to, from, next) => {
    // 设置页面标题
    if (to.path === '/consultationBook/add') {
      document.title = to.query.consultationBookId ? '修改咨询线索' : '新增咨询线索'
    } else {
      document.title = to.meta.title || '默认标题'
    }
    next()
})

// 全局错误处理器
app.config.errorHandler = (err, vm, info) => {
  // 处理错误...
  console.error('Global Error Handler:', err, info);
  message.error('系统出现错误，请稍后再试');
};
